<template>
    <div id="secondStep" class="step">
        <div class="fieldset-content">
            <div class="row">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="notifications">{{ $t('textTenants.textTittleNotifications') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ul id="notifications" class="list-group list-group-horizontal justify-content-between border-enable">
                                <li class="list-group-item"><ejs-radiobutton :label="$t('textTenants.notification.textActive')" :checked="notifications==1" name="status" cssClass="e-primary" id="notificationsActive"></ejs-radiobutton></li>
                                <li class="list-group-item"><ejs-radiobutton :label="$t('textTenants.notification.textInactive')" :checked="notifications==0" name="status" cssClass="e-primary"></ejs-radiobutton></li>
                            </ul>
                        </div>
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="client">{{ $t('textTenants.textCloneThemes') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-autocomplete :dataSource='dataSourceClient' :fields='fieldsClient' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textTenants.textFormSelect')" :select='onChangeClient'></ejs-autocomplete>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-12 col-lg-6 col-sm-6 control">
                            <label for="themes">{{ $t('textTenants.textTittleThemes') }}</label>
                            <ejs-listbox id="themes" :dataSource='dataSourceThemes' scope="#licenses" :fields="fields" :toolbarSettings="toolbarSettings"></ejs-listbox>
                        </div>
                        <div class="col-12 col-lg-6 col-sm-6 control">
                            <label for="licenses">{{ $t('textTenants.textAssociatedTopics') }}</label>
                            <ejs-listbox id="licenses" :dataSource='dataSourceLicences' :fields="fields" scope="combined-list"></ejs-listbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-12 label control">
                            <label for="StructuringUser">{{ $t('textTenants.textTittleStructuringUser') }}</label>
                        </div>
                        <div class="col-9 col-lg-10 col-sm-12 control">
                            <ejs-multiselect 
                             v-model="StructuringUser" 
                             id="structuring_user"
                             cssClass="e-outline" 
                             mode="Box"
                             :dataSource="dataSourceUsers" 
                             :fields="{text: 'name', value: 'id' }"
                             :placeholder="$t('textTenants.textFormSelect')"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-12 label control">
                            <label for="StructuringUser">Alertas vencimiento (días)</label>
                        </div>
                        <div class="col-9 col-lg-10 col-sm-12 control">
                            <ejs-multiselect
                             id="structuring_expiration_days"
                             v-model="expiration_days_tenant"
                             cssClass="e-outline" 
                             mode="Box"
                             :dataSource="expiration_days_system"
                             allowCustomValue="true"
                             placeholder="Seleccione los días de alerta de vencimiento"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-tenant-footer numberPage='2' numberOfPages='3' previousId="previousStep2" nextId="nextStep2"></create-tenant-footer>
    </div>
</template>

<script>
import axios from 'axios'
import { ListBoxPlugin } from "@syncfusion/ej2-vue-dropdowns";
Vue.use(ListBoxPlugin);

export default {
    name: "create-tenant-second-step",
    data () {
		return {
            notifications: 1,
            fieldsClient : {value: 'razonSocial'},
            dataSourceLicences : {default: '',},
            StructuringUser : [],
            fields: { text: "tema", value: 'id'},
            toolbarSettings: { items: ['moveTo', 'moveFrom', 'moveAllTo', 'moveAllFrom'] },
            dataSourceThemes : [],
            dataSourceClient : [],
            dataSourceUsers  : [],
            expiration_days_system: [],
            expiration_days_tenant: []
        }
    },
	methods: {
        setSelectItems: function(data) {
            let themes = document.getElementById("themes").ej2_instances[0];
            themes.moveAllItemFrom();
            let selectThemes = [];
            for(var i = 0; i < data.length; i++){
                selectThemes.push(data[i].tema);
            }
            themes.selectItems(selectThemes);
            themes.moveTo();
        },
        initEditTenantSecondStep: function() {
            Vue.prototype.$eventHub.$emit('onShowSpinner');
            axios.post('/auth/tenants/getTenants').then(response => {
                this.dataSourceClient = response.data;
            });
            axios.get('/system/getExpirationDays').then(response => {
                this.expiration_days_system = response.data;
            });
            axios.post('/auth/users/getUsersStructuring').then(response => {
                this.dataSourceUsers = response.data;
            });
            axios.post('/auth/tenants/getLicenceThemes').then(response => {
                this.dataSourceThemes = response.data;
                if(!!this.$route.params.id) {
                    axios.post('/auth/tenants/getInitEditTenantSecondStep', {
                        tenantId: this.$route.params.id,
                    }).then(responseP => {
                        this.StructuringUser = responseP.data.users;
                        this.notifications = responseP.data.activo_notificacion;
                        this.expiration_days_tenant = responseP.data.expiration_days_tenant;
                        this.setSelectItems(responseP.data.license);
                        Vue.prototype.$eventHub.$emit('onHideSpinner');
                    });
                }else{
                    this.expiration_days_tenant = [60,30,15,5,1];
                    Vue.prototype.$eventHub.$emit('onHideSpinner');
                }
            });
        },
        onChangeClient: function(args) {
            axios.post('/auth/tenants/getLicenceThemes', {
                TID: args.itemData.TID
            }).then(response => {
                this.setSelectItems(response.data);
			});
        },
        btnClicked: function(args) {
			Vue.prototype.$eventHub.$emit('onChangeTabWizard', args);
        }
	},
	created: function() {
		this.initEditTenantSecondStep();
	}
}
</script>